import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPhoneStethoscope = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.625 16.375C17.625 16.8723 17.8225 17.3492 18.1742 17.7008C18.5258 18.0525 19.0027 18.25 19.5 18.25C19.9973 18.25 20.4742 18.0525 20.8258 17.7008C21.1775 17.3492 21.375 16.8723 21.375 16.375C21.375 15.8777 21.1775 15.4008 20.8258 15.0492C20.4742 14.6975 19.9973 14.5 19.5 14.5C19.0027 14.5 18.5258 14.6975 18.1742 15.0492C17.8225 15.4008 17.625 15.8777 17.625 16.375V16.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 7.625V11.375C2.625 13.0326 3.28348 14.6223 4.45558 15.7944C5.62768 16.9665 7.2174 17.625 8.875 17.625C10.5326 17.625 12.1223 16.9665 13.2944 15.7944C14.4665 14.6223 15.125 13.0326 15.125 11.375V7.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.625 16.375C16.962 16.375 16.3261 16.6384 15.8572 17.1072C15.3884 17.5761 15.125 18.212 15.125 18.875C15.125 19.538 14.8616 20.1739 14.3928 20.6428C13.9239 21.1116 13.288 21.375 12.625 21.375H11.375C10.712 21.375 10.0761 21.1116 9.60723 20.6428C9.13839 20.1739 8.875 19.538 8.875 18.875V17.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 2.625H12.625V13.875H5.125V2.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 11.0625C8.95788 11.0625 9.03737 11.0954 9.09597 11.154C9.15458 11.2126 9.1875 11.2921 9.1875 11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5625 11.375C8.5625 11.2921 8.59542 11.2126 8.65403 11.154C8.71263 11.0954 8.79212 11.0625 8.875 11.0625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 11.6875C8.79212 11.6875 8.71263 11.6546 8.65403 11.596C8.59542 11.5374 8.5625 11.4579 8.5625 11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.1875 11.375C9.1875 11.4579 9.15458 11.5374 9.09597 11.596C9.03737 11.6546 8.95788 11.6875 8.875 11.6875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPhoneStethoscope.displayName = 'SvgPhoneStethoscope';
export default SvgPhoneStethoscope;
